import { FC, ReactNode, useMemo } from 'react';

import { IndeterminateCheckbox } from '../IndeterminateCheckbox/IndeterminateCheckbox';

export interface FormHeaderCheckboxProps {
  id: string;
  e2e?: string;
  isNoFormSelected: boolean;
  areAllFormsSelected: boolean;
  isDisabled?: boolean;
  onToggle(): void;
  hasCustomClass?: boolean;
  margin?: string;
  text?: string | ReactNode;
}
export const FormHeaderCheckbox: FC<FormHeaderCheckboxProps> = ({
  id,
  e2e,
  isNoFormSelected,
  areAllFormsSelected,
  isDisabled = false,
  onToggle,
  text,
}) => {
  const checkboxValue = useMemo(() => {
    if (isNoFormSelected && areAllFormsSelected) {
      return undefined;
    } else if (!isNoFormSelected && !areAllFormsSelected) {
      return 'INDETERMINATE';
    } else if (areAllFormsSelected) {
      return true;
    } else {
      return false;
    }
  }, [areAllFormsSelected, isNoFormSelected]);

  return (
    <IndeterminateCheckbox
      id={id}
      e2e={e2e}
      value={checkboxValue}
      isDisabled={isDisabled}
      onToggle={onToggle}
      text={text}
    />
  );
};
